import { MdKeyboardArrowDown } from 'react-icons/md';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const DropdownIcon = styled(MdKeyboardArrowDown)`
  font-size: 20px;
  color: ${({ theme }) => theme.dashboard.dropdownColor} !important;
  margin-left: 3px;
`;

export const DropdownFilter = styled.div`
  display: flex;
  font-size: 12px;
  align-items: center;
  justify-content: center;
  width: 136px;
  height: 48px;
  border-radius: 25px;
  margin-left: auto;
  border: 2px solid ${({ theme }) => theme.dashboard.dropdownColor};
  color: ${({ theme }) => theme.dashboard.dropdownColor};
  background: ${ColorPalette.HEX.White};
  font-weight: 600;
  cursor: pointer;
`;
